module.exports = __webpack_public_path__ + "static/media/start-btn-highlight-xl.a84ae05c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/start-btn-highlight-xl.png
// module id = 608
// module chunks = 0